/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { useParams } from "react-router-dom";
import { useDashboardUrlConfigs } from "../context/Provider";
import { ContentLayout, PanelContainer } from "../../../components/Common";
import { makeStyles } from "@material-ui/core";

/**
 * This component renders the opensearch dashboards using proxy middleware URL.
 * As the Cognito login is not supported in IFrame, we have implemented proxy APIs for patching the login to allow in IFrame.
 * Component modifies the URL to send the requests to Proxy URLs and there by Opensearch domain.
 */

const useStyles = makeStyles({
	iframe: {
		height: "calc(100vh - 94px)",
		width: "100%",
		border: 0,
	},
});

const Dashboards = () => {
	//replacing opensearch domain with proxy domain
	const { reportId } = useParams();
	const { dashboardUrls, proxyEndpoint } = useDashboardUrlConfigs();
	const classes = useStyles();

	const getProxyDashboardUrl = () => {
		const dashboardUrl = dashboardUrls.find((url) => url.reportId === reportId) || {};
		let newUrl = dashboardUrl.reportUrl?.replace(/.*\/\/[^/]*/, ""); // Removes OpenSearch domain from the configured proxy URL
		newUrl = `${proxyEndpoint}${newUrl}&embed=true`;
		const encodedUrl = encodeURIComponent(newUrl); // used for setting cookies.
		const urlObject = new URL(newUrl);
		return `${urlObject.origin}${urlObject.pathname}?paceRedirectUrl=${encodedUrl}${urlObject.hash}`;
	};

	const proxyUrl = getProxyDashboardUrl();

	return (
		<ContentLayout style={{ maxWidth: "100%" }}>
			<PanelContainer>
				<iframe className={classes.iframe} title="Supervisor dashboards." src={proxyUrl}></iframe>
			</PanelContainer>
		</ContentLayout>
	);
};

export default Dashboards;
